import React, {useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import Post from "../../../components/Posts/Post/Post";
import Comments from "../../../components/Comments/Comments";
import * as actions from "../../../store/actions";
import {LoadingIcon} from "../../../components/Loading/Loading";

const DetailedPost = (props) => {

    const [commentValue, setCommentValue] = useState("")

    const token = useSelector(state => state.auth.token)
    const isAuth = useSelector(state => state.auth.token !== null)
    const userId = useSelector(state => state.auth.userId)
    const username = useSelector(state => state.auth.username)

    const postId = new URLSearchParams(props.location.search).get("id")
    const postData = useSelector(state => state.post.posts)[0]
    const postLoading = useSelector(state => state.post.loading)
    const dispatch = useDispatch()

    const postDataFromRouterState = props.location.state?.postData
    useEffect(() => {
        if (!postDataFromRouterState) {
            //console.log("DetailedPost fetch post data")
            dispatch(actions.postInit())
            const postUrl = "/posts/" + postId + ".json"
            dispatch(actions.detailedPost(postUrl, postId))
        } else {
            //console.log("Detailed post got data from state")
            dispatch(actions.postSuccess([postDataFromRouterState]))
        }

        const commentUrl = "/postcomments/" + postId + ".json"
        dispatch(actions.postComment(commentUrl))

    }, [postId, postDataFromRouterState, dispatch])

    useEffect(() => {
        if (postData?.title) {
            document.title = postData.title
        }
    }, [postData])

    const commentData = useSelector(state => state.comment.comments)
    const commentLoading = useSelector(state => state.comment.commentLoading)
    const commentSubmitLoading = useSelector(state => state.comment.commentSubmitLoading)

    const submitComment = useCallback((postId, commentData, postOwnerUserId, points, token) =>
        dispatch(actions.postCommentSubmit(postId, commentData, postOwnerUserId, points, token)), [dispatch])

    const onSubmitComment = useCallback((event) => {
        event.preventDefault()
        if (!isAuth) {
            props.history.push({
                pathname: "/auth",
                search: "?goto=" + props.location.pathname.substring(1) + props.location.search
            })
            return;
        }
        if (commentValue.length < 6) return;
        const commentData = {
            postId: postId,
            commentBody: commentValue,
            createdOn: new Date(),
            userId: userId,
            author: username,
            points: 0,
            upVoteBy: null
        }
        submitComment(postId, commentData, postData.userId, +postData.comments, token)
        setCommentValue("")
    }, [isAuth, commentValue, postId, postData, userId, username, submitComment, props.location, props.history])

    return (
        <div style={{padding: "8px"}}>
            {!postLoading ? <table>
                <Post {...postData} showId={false}/>
                <tbody>
                <tr>
                    <td colSpan="2"/>
                    <td>
                        <form onSubmit={onSubmitComment}>
                        <textarea name="text" rows="6" cols="60"
                                  value={commentValue}
                                  onChange={(event) => {
                                      setCommentValue(event.target.value)
                                  }}/>
                            <br/><br/>
                            <button disabled={commentValue.length < 6} type="submit">add comment</button>
                            &nbsp;&nbsp;
                            {commentSubmitLoading ? <LoadingIcon size="0.75rem"/> : null}
                        </form>
                    </td>
                </tr>
                </tbody>
            </table> : "Loading..."}
            <br/><br/>
            {commentLoading ? "Loading..." : <Comments commentData={commentData}/>}
        </div>
    )
}

export default DetailedPost;